/**
 * User configuration strings.
 *
 * Help text (h_) was migrated from the inline renderHelpLabel JSX in
 * src/Configuration/UserManagement/UserCard.tsx — verify against the implementation.
 */
export default {
    d_password: 'Password',
    h_password: '<div>To enforce secure passwords, Outlaw Practice follows the OWASP guidelines for passwords.</div><div>Specifically, passwords must be at least 8 characters long (maximum of 128), and must use a mixture of lower and upper-case characters, numbers and symbols.</div>',
};
